import React, { useState } from "react";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import DataTable from "../../components/Elements/DataTable/DataTable";
import MainButton from "../../components/Elements/MainButton/MainButton";

import { fetchRolesAdmin } from "../../services/RoleService";
import AdminCreateRoleModal from "../../components/AdminPages/AdminCreateRoleModal";

// Visible columns for roles table
const columns = [
  { key: "id", label: "ID" },
  { key: "name", label: "Name" },
  { key: "rate", label: "Rate" },
  { key: "cutoff", label: "Cutoff" },
];

// No optional columns yet, reserved for future
const optionalColumns = [];

// Sort options
const sortOptions = [
  { value: "id", label: "ID" },
  { value: "name", label: "Name" },
];

// Filter definitions
const filterDefinitions = [
  { key: "id", label: "ID", type: "text" },
  { key: "name", label: "Name", type: "text" },
];

// Custom renderers for numeric fields
const customRenderers = {
  rate: (item) => (item.rate === null || item.rate === undefined ? "-" : String(item.rate)),
  cutoff: (item) => (item.cutoff === null || item.cutoff === undefined ? "-" : String(item.cutoff)),
};

const AdminRoles = () => {
  const [dataVersion, setDataVersion] = useState(0);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const fetchDataFn = (params) => fetchRolesAdmin(params);

  const handleCreated = () => {
    setShowCreateModal(false);
    setDataVersion((v) => v + 1);
  };

  const createButton = <MainButton onClick={() => setShowCreateModal(true)}>Create +</MainButton>;

  return (
    <div className="admin-roles-page">
      <PageHeader title="Roles" description="View, edit and manage all roles" actions={createButton} />

      <DataTable
        key={dataVersion}
        tableId="admin-roles"
        fetchDataFunction={fetchDataFn}
        columns={columns}
        optionalColumns={optionalColumns}
        sortOptions={sortOptions}
        filterDefinitions={filterDefinitions}
        defaultSortBy="id"
        itemKey="id"
        customRenderers={customRenderers}
        rowActions={[]}
        showCheckboxes={false}
        showFilters={false}
        showPageSize={false}
      />

      <AdminCreateRoleModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onCreated={handleCreated}
      />
    </div>
  );
};

export default AdminRoles;
